
import AuthorizationCard from "./AuthorizationCard";
import VuexSnackbar from "./VuexSnackbar";
import DateTimeLocalField from "./DateTimeLocalField";
import PlainTextComponent from "./PlainTextComponent";
import PlainTextDiv from "./PlainTextDiv";
import PlainCheck from "./PlainCheck";
import ConfirmNavigationDialog from "./ConfirmNavigationDialog";
import MotPasseField from "./MotPasseField";
import IssueTeleserviceIcon from "./IssueTeleserviceIcon";
import TooltipIconButton from "./TooltipIconButton";
import LiensUtiles from "./LiensUtiles";

export default {
    install(Vue) {
        Vue.component("a-authorization-card", AuthorizationCard);
        Vue.component("a-vuex-snackbar", VuexSnackbar);
        Vue.component("a-datetime-local-field", DateTimeLocalField);
        Vue.component("a-plain-text-component", PlainTextComponent);
        Vue.component("a-plain-text-div", PlainTextDiv);
        Vue.component("a-plain-check", PlainCheck);
        Vue.component("a-confirm-navigation-dialog", ConfirmNavigationDialog);
        Vue.component("a-motpasse-field", MotPasseField);
        Vue.component("a-issue-teleservice-icon", IssueTeleserviceIcon);
        Vue.component("a-tooltip-icon-button", TooltipIconButton);
        Vue.component("a-cgu-faq-link", LiensUtiles);
    }
}
